module.exports = __webpack_public_path__ + "img/decathlon_logo.92e2857c.png";